import { render, staticRenderFns } from "./pin-details-form.component.vue?vue&type=template&id=1ba237d9"
import script from "./pin-details-form.component.ts?vue&type=script&lang=ts&external"
export * from "./pin-details-form.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports